import { render, staticRenderFns } from "./EditAboutMeDialog.vue?vue&type=template&id=f68d4290&scoped=true&"
import script from "./EditAboutMeDialog.vue?vue&type=script&lang=js&"
export * from "./EditAboutMeDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditAboutMeDialog.vue?vue&type=style&index=0&id=f68d4290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68d4290",
  null
  
)

export default component.exports